import styled, { useTheme } from 'styled-components';
import Button from '../../../../components/Button';
import ColorizedSpan from '../../../../components/Colorized';
import { useEffect, useRef, useState } from 'react';
import WidthContainer from '../../../../components/WidthContainer';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import { usePrivy } from '@privy-io/react-auth';
import { useNavigate } from 'react-router-dom';
import { hapticsImpactLight } from '../../../../common/haptic';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: fit-content;
  min-height: 500px;
  justify-content: space-between;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    padding-top: 50px;
    text-align: center;
  }
`;

const Title = styled.h1`
  font-size: 64px;
  font-weight: 500;
  line-height: 77px;
  letter-spacing: -2%;
  color: ${({ theme }) => theme.text.title};
  @media ${PHONE_MEDIA_QUERY} {
    font-size: 2.5rem;
    line-height: 2.8rem;
  }
`;

const SubTitle = styled.h2`
  font-size: 24px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: -2%;
  color: ${({ theme }) => theme.text.title};
  @media ${PHONE_MEDIA_QUERY} {
    font-size: 1rem;
    line-height: 1.2rem;
  }
`;

const Column = styled.div`
  width: 100%;
  display: flex;
  gap: 30px;
  flex-direction: column;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 15px;
  }
`;

const MobileImage = styled.img`
  width: 436px;
  object-fit: cover;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  cursor: pointer;
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
`;

const ContainerBackground = styled.div`
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.background.primary} 0%,
    ${({ theme }) => theme.primary.background} 100%
  );
  position: absolute;
  width: 100%;
  left: 0px;
`;

const Hero = () => {
  const { user } = usePrivy();
  const backgroundRef = useRef(null);
  const [siblingHeight, setSiblingHeight] = useState(undefined);

  useEffect(() => {
    const updateHeight = () => {
      if (backgroundRef.current) {
        setSiblingHeight(backgroundRef.current.offsetHeight);
      }
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const navigate = useNavigate();

  const theme = useTheme();

  return (
    <>
      <ContainerBackground ref={backgroundRef}>
        <WidthContainer>
          <Container>
            <Column>
              <Title>
                Next-generation <br />
                <ColorizedSpan>gift cards.</ColorizedSpan>
              </Title>
              <SubTitle style={{ color: theme.text.regular }}>
                Personal. Instant. Built for value that doesn’t sit still.
              </SubTitle>
              <Button
                onClick={() => {
                  window.location.href = 'https://deks.xyz/login';
                }}
                style={{ marginBottom: isMobile ? '50px' : '0px' }}
                fullWidth={isMobile}
              >
                SEND A GIFT NOW
              </Button>
            </Column>
            <Column style={{ width: 'fit-content' }}>
              <MobileImage
                onClick={() => {
                  hapticsImpactLight();
                  window.location.href = 'https://deks.xyz/login';
                }}
                src='/landing-v2/hero-mobile.webp'
              />
            </Column>
          </Container>
        </WidthContainer>
      </ContainerBackground>
      <div style={{ height: siblingHeight }} />
    </>
  );
};

export default Hero;
